export const TERMS_VERSION = "2026-09-16";
export const PRIVACY_NOTICE_VERSION = "2026-09-16";
export const MARKETING_CONSENT_VERSION = "member-updates-2026-09-16";

export const TERMS_PATH = "/terms";
export const PRIVACY_NOTICE_PATH = "/privacy";

export const MARKETING_CONSENT_COPY =
  "Send me invitations, new experiences, and updates. I can unsubscribe at any time.";
